import { createStyles, makeStyles } from '@material-ui/core/styles';
import { STYLE } from '../../../../constants';
import { toREM } from '../../../../utils/generalUtils';

export const useStyles = makeStyles(theme =>
  createStyles({
    parent: {
      display: 'flex',
      flexDirection: 'column',
      // width: '100%',
      height: '100vh',
      justifyContent: 'space-between',
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: `0 2.5rem`,
      marginTop: toREM(20),
    },
  })
);
